import { render, staticRenderFns } from "./TypeRadarChart.vue?vue&type=template&id=74953c46&scoped=true&"
import script from "./TypeRadarChart.vue?vue&type=script&lang=js&"
export * from "./TypeRadarChart.vue?vue&type=script&lang=js&"
import style0 from "./TypeRadarChart.vue?vue&type=style&index=0&id=74953c46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74953c46",
  null
  
)

export default component.exports